import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    data: {
        catalogos: undefined,
        imagenesCatalogo: [],
        publicados: undefined,
        selectedCatalogo: undefined,
        idCatalogo:undefined,
        catalogoCompleto: undefined,
        imagenesArticulo: [],
        imagenesActualizadas: false,
        catalogoAuxiliar: undefined,
        articuloAgregar: undefined
    }
})

export default function catalogoReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SAGA_INITIAL_STATE){
    
        return initialState.setIn(["data", "imagenesCatalogo"], state.getIn(["data", "imagenesCatalogo"]))
                           .setIn(["data", "imagenesArticulo"], state.getIn(["data", "imagenesArticulo"]))
                           
    }

    if (action.type === ReducerActions.SAGA_INITIAL_STATE_RELOAD_ALL) {
        return initialState
    }

    if(action.type === ReducerActions.SET_CATALOGOS){
        return state.setIn(["data", "catalogos"], action.payload)
    }

    if(action.type === ReducerActions.ADD_ARTICULO_CATALOGO){
        let articuloAgregar = action.payload
        let myState = state.toJS()
        let catalogoCompleto = myState.data.catalogoCompleto
        let rubrosAgregar = catalogoCompleto.listaRubros.filter(x => x.idRubro === articuloAgregar.rubroClass.idRubro)


        
        //vamos a preguntar si entra en los rubros, si entra seguimos bien, sino creamos uno nuevo.
        if (rubrosAgregar.length > 0 ){ 
            //Si se cumple, vamos a buscar el subrubro.
            let subrubrosAgregar = rubrosAgregar[0].listaSubRubros.filter(x => x.idSubrubro === articuloAgregar.subrubroClass.idSubRubro)

            if (subrubrosAgregar.length > 0) {
                //Si sigue cumpliendo, pasaremos a insertar el archivos.
                subrubrosAgregar[0].listaArticulos.push(articuloAgregar)
                
            } // trabajar en el else
        }

        
        return state.setIn(["data", "articuloAgregar"], action.payload)
                    .setIn(["data", "catalogoCompleto"], catalogoCompleto)
    }


    if (action.type === ReducerActions.SET_IMAGEN_CATALOGO) {
    
        let myState = state.toJS()
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                imagenesCatalogo: [...myState.data.imagenesCatalogo, action.payload]
            }
        })
    }

    if(action.type === ReducerActions.SET_CATALOGO_COMPLETO){
        return state.setIn(["data", "catalogoCompleto"], action.payload)
        .setIn(["data", "imagenesArticulo"], fromJS([]))
    }

    if(action.type === ReducerActions.SET_CATALOGO_COMPLETO_AUXILIAR){
        return state.setIn(["data", "catalogoAuxiliar"], action.payload)
        .setIn(["data", "imagenesArticulo"], fromJS([]))
    }

    if (action.type === ReducerActions.SET_IMAGENES_ARTICULO) {
    
        let myState = state.toJS()
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                imagenesArticulo: [...myState.data.imagenesArticulo, action.payload]
            }
        })
    }

    if(action.type === ReducerActions.REMOVE_IMAGENES_ARTICULO){
        
        let myState = state.toJS()

        // obtengo el index del articulo modificado
        let index = myState.data.imagenesArticulo.findIndex((ia) => ia.idArticulo === action.payload)
        if(index === -1)
            return fromJS({ ...myState })

        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                imagenesArticulo: [
                    ...myState.data.imagenesArticulo.slice(0, index),
                    ...myState.data.imagenesArticulo.slice(index + 1)
                ],
                imagenesActualizadas: true
            }
        })
    }

    if(action.type === ReducerActions.SET_IMAGENES_ACTUALIZADAS){
        return state.setIn(["data", "imagenesActualizadas"], action.payload)
    }

    if(action.type === ReducerActions.SET_PUBLICADOS){
        return state
        .setIn(["data", "publicados"], action.payload)
        .setIn(["data", "selectedCatalogo"], (action.payload.length > 0)?action.payload[0].idCatalogo:undefined)
    }
    if(action.type === ReducerActions.SET_SELECTED){
        return state
        .setIn(["data", "selectedCatalogo"], action.payload)
    }

    if(action.type === ReducerActions.SET_IDCATALOGO){
        return state
        .setIn(["data", "idCatalogo"], action.payload)
    }

    if(action.type === ReducerActions.SET_CATALOGO_COMPLETO_AUX){
        return state.setIn(["data", "catalogoCompleto"], action.payload)
    }

    if(action.type === ReducerActions.BORRAR_ARTICULO_CATALOGO_COMPLETO){
        
        let myState = state.toJS()
        let idRubro = 0
        let idSubrubro = 0
        let catalogoCompleto = myState.data.catalogoCompleto

        catalogoCompleto.listaRubros.forEach((r,i) => {
            r.listaSubRubros.forEach((s,j) => {
                s.listaArticulos.forEach((a) => {
                    if(a.idArticulo === action.payload){
                        idRubro = i
                        idSubrubro = j
                    }
                })
            })
        });

        let listaArticulos = catalogoCompleto.listaRubros[idRubro].listaSubRubros[idSubrubro].listaArticulos
        catalogoCompleto.listaRubros[idRubro].listaSubRubros[idSubrubro].listaArticulos = listaArticulos.filter((a) => a.idArticulo !== action.payload)
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                catalogoCompleto: catalogoCompleto
            }
        })
    }

    if(action.type === ReducerActions.ADD_ARTICULO_CATALOGO_COMPLETO){
         //comenzar a ver aqui.
        let myState = state.toJS()

        let idRubro = action.payload.IdRubro
        let idSubrubro = action.payload.IdSubrubro
        
        let catalogoCompleto = myState.data.catalogoCompleto

        catalogoCompleto.listaRubros[idRubro-1].listaSubRubros[idSubrubro-1].listaArticulos.push(action.payload)
    

        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                catalogoCompleto: catalogoCompleto
            }
        })
    }

    if(action.type === ReducerActions.CAMBIAR_ARTICULO_DE_SUBRUBRO){
        
        let myState = state.toJS()
        let rubro
        let subrubro
        let indiceSubrubroNuevo
        let idSubRubro
        let catalogoCompleto = {...myState.data.catalogoCompleto}
        let flag = false

        catalogoCompleto.listaRubros.forEach((r,i) => {
            r.listaSubRubros.forEach((s,j) => {
                if(s.idSubrubro === action.payload.subRubroNuevo.idSubrubro){
                    indiceSubrubroNuevo = j
                    flag = true
                }
                s.listaArticulos.forEach((a) => {
                    if(a.idArticulo === action.payload.idArticulo){
                        rubro = i
                        subrubro = j
                        idSubRubro = s.idSubrubro
                    }
                })
            })
        });

        let listaArticulos = catalogoCompleto.listaRubros[rubro].listaSubRubros[subrubro].listaArticulos
        catalogoCompleto.listaRubros[rubro].listaSubRubros[subrubro].listaArticulos = listaArticulos.filter((a) => a.idArticulo !== action.payload.idArticulo)
        let articulo = listaArticulos.filter((a) => a.idArticulo === action.payload.idArticulo)

        // si ya existe el subrubro en el catalogoCompleto
        if(flag){
            catalogoCompleto.listaRubros[rubro].listaSubRubros[indiceSubrubroNuevo].listaArticulos.push(articulo[0])
        }
        else{ // si no existe el subrubro en el catalogoCompleto lo creo y lo agrego con el articulo
            let nuevoSubrubro = action.payload.subRubroNuevo
            nuevoSubrubro.tieneEntradasActivas = true
            nuevoSubrubro.listaArticulos = articulo
            catalogoCompleto.listaRubros[rubro].listaSubRubros.push(nuevoSubrubro)
        }

        if(catalogoCompleto.listaRubros[rubro].listaSubRubros[subrubro].listaArticulos.length === 0){
            catalogoCompleto.listaRubros[rubro].listaSubRubros = catalogoCompleto.listaRubros[rubro].listaSubRubros.filter((s) => s.idSubrubro !== idSubRubro)
        }

        catalogoCompleto.listaRubros[rubro].listaSubRubros = catalogoCompleto.listaRubros[rubro].listaSubRubros.sort((a,b) => (a.orden > b.orden) ? 1 : ((b.orden > a.orden) ? -1 : 0))
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                catalogoCompleto: catalogoCompleto
            }
        }) 
    }

    return state
}